<script setup lang="ts">
import AdminTopBar from '@/modules/admin/components/AdminTopBar.vue';
</script>

<template>
  <div class="main-wrapper">
    <div class="content-wrapper">
      <AdminTopBar />
      <div class="content">
        <RouterView />
      </div>
    </div>
  </div>
</template>

<style scoped>
.main-wrapper {
  position: relative;
  height: 100%;
  min-height: 0;
  background-color: #eee;
}

.content-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.content {
  flex: 1;
  min-height: 0;
}
</style>
